import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from "@angular/forms";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatDatepicker, MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import _moment from "moment";

export const YEAR_FORMATS = {
	parse: {
		dateInput: "YYYY",
	},
	display: {
		dateInput: "YYYY",
		monthYearLabel: "YYYY",
		dateA11yLabel: "LL",
		monthYearA11yLabel: "YYYY",
	},
};

const moment = _moment;

@Component({
	selector: "app-year-picker",
	templateUrl: "./year-picker.component.html",
	styleUrls: ["./year-picker.component.scss"],
	standalone: true,
	imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatDatepickerModule],
	providers: [
		{
			provide: DateAdapter,
			useClass: MomentDateAdapter,
			deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
		},

		{ provide: MAT_DATE_FORMATS, useValue: YEAR_FORMATS },
	],
})
export class YearPickerComponent implements OnInit {
	@Input() title?: string;
	@Input() defaultValue?: string;

	@Output() valueChangeEvent = new EventEmitter<Date>();

	formControl = new UntypedFormControl();

	constructor() {}

	ngOnInit() {
		if (!this.title) {
			this.title = "Select Year";
		}
		if (this.defaultValue == null) return;
		const myDate = new Date(this.defaultValue);
		let ctrlValue = this.formControl.value;
		if (ctrlValue == null) {
			ctrlValue = moment();
		}
		ctrlValue.year(myDate.getFullYear());
		this.formControl.setValue(ctrlValue);
	}

	handleYearChange(ev: any, dp: MatDatepicker<any>) {
		const myDate = new Date(ev);
		let ctrlValue = this.formControl.value;
		if (ctrlValue == null) {
			ctrlValue = moment();
		}
		ctrlValue.year(myDate.getFullYear());
		this.formControl.setValue(ctrlValue);
		this.valueChangeEvent.emit(this.formControl.value);
		dp.close();
	}
}
